import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgComponent = ({ title, titleId, ...props }) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M4.5.75H19a1 1 0 0 1 1 1v18.5a3 3 0 0 1-3 3H4.5a1 1 0 0 1-1-1V1.75a1 1 0 0 1 1-1Z",
			stroke: "#262626",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.5 3.75H7a.5.5 0 0 0-.5.5v6.5a.5.5 0 0 0 .5.5h9.5a.5.5 0 0 0 .5-.5v-6.5a.5.5 0 0 0-.5-.5ZM8 14.25v3m1.5-1.5h-3",
			stroke: "#262626",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.25 15.375a.375.375 0 0 1 0-.75m0 .75a.375.375 0 0 0 0-.75m-3 3a.375.375 0 0 1 0-.75m0 .75a.375.375 0 0 0 0-.75",
			stroke: "#262626",
			strokeWidth: 1.5,
			fill: "#000"
		})
	]
});
export const ReactComponent = SvgComponent;
export default "data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20fill%3D%22none%22%20width%3D%2224%22%20height%3D%2224%22%20viewBox%3D%220%200%2024%2024%22%3E%3Cpath%20d%3D%22M4.5.75H19a1%201%200%200%201%201%201v18.5a3%203%200%200%201-3%203H4.5a1%201%200%200%201-1-1V1.75a1%201%200%200%201%201-1Z%22%20stroke%3D%22%23262626%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%20stroke-width%3D%221.5%22%2F%3E%3Cpath%20d%3D%22M16.5%203.75H7a.5.5%200%200%200-.5.5v6.5a.5.5%200%200%200%20.5.5h9.5a.5.5%200%200%200%20.5-.5v-6.5a.5.5%200%200%200-.5-.5ZM8%2014.25v3m1.5-1.5h-3%22%20stroke%3D%22%23262626%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%20stroke-width%3D%221.5%22%2F%3E%3Cpath%20d%3D%22M16.25%2015.375a.375.375%200%200%201%200-.75m0%20.75a.375.375%200%200%200%200-.75m-3%203a.375.375%200%200%201%200-.75m0%20.75a.375.375%200%200%200%200-.75%22%20stroke%3D%22%23262626%22%20stroke-width%3D%221.5%22%20fill%3D%22%23000%22%2F%3E%3C%2Fsvg%3E";
